import { render, staticRenderFns } from "./IconTextLink.vue?vue&type=template&id=018951fa&scoped=true&name=icon-text-link&"
import script from "./IconTextLink.vue?vue&type=script&lang=js&"
export * from "./IconTextLink.vue?vue&type=script&lang=js&"
import style0 from "./IconTextLink.vue?vue&type=style&index=0&id=018951fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018951fa",
  null
  
)

export default component.exports